<div class="profile-card">
  <div class="profile-card-content">
    <div class="profile-card-user">
      <div class="profileImage" [ngClass]="{'has-image': !!userProfile?.profile_image_url}">
        <img
          *ngIf="userProfile?.profile_image_url"
          appDisableRightClick
          appMobileOptimization
          [originalUrl]="userProfile?.profile_image_url"
          [src]="userProfile?.profile_image_url"
          [format]="'webp'"
          alt="Profile"
          loading="lazy"
          decoding="async"
        />
      </div>
      <div class="profile-card-info">
        <h3>{{ fullName }}</h3>
        <p>
          {{ userProfile?.general_location }}
        </p>
      </div>
    </div>
  </div>
</div>
